import RequireRole from "@/components/feature/panel/RequireRole";
import RolePanelShell from "@/components/feature/panel/RolePanelShell";
import { adminConfig } from "@/data/panels";

export default function AdminLayout() {
  return (
    <RequireRole role="admin">
      <RolePanelShell {...adminConfig} />
    </RequireRole>
  );
}